"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Form = exports.removeFalsyFields = exports.checkPageIsValid = exports.checkIsPagedInterface = exports.countPages = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

var _react = _interopRequireWildcard(require("react"));

var _fieldOld = _interopRequireDefault(require("./fieldOld"));

var _formElements = require("@evidation/form-elements");

var _transformSchema = _interopRequireDefault(require("./transformSchema"));

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("./constants");

var _generateFieldPageDictionary = _interopRequireDefault(require("./generateFieldPageDictionary"));

var _reduxForm = require("redux-form");

var _utils = require("./utils");

var _refs = require("./utils/refs");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactRedux = require("react-redux");

var _logger = require("@evidation/logger");

var _commonComponents = require("./commonComponents");

var _LanguageContext = _interopRequireDefault(require("./contexts/LanguageContext"));

var _SubmissionError = _interopRequireDefault(require("./SubmissionError"));

var _excluded = ["onModifySchema", "handleSubmit", "noPaging", "fieldSpacing", "nowDate", "form", "editableFields", "editableInterface", "children", "schema", "clear_editing_field", "error", "perPageValidation", "syncErrors", "asyncErrors", "valid", "invalid", "components", "participant", "translationLocale"],
    _excluded2 = ["style"],
    _excluded3 = ["editable", "component", "key"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

(0, _styledComponents.createGlobalStyle)(["", ""], _commonComponents.CustomInputStyles);

var FieldWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FormOld__FieldWrapper"
})(["padding-bottom:", ";"], function (props) {
  return props.fieldSpacing ? "".concat(props.fieldSpacing, "px") : 0;
});

var Wrapper = function Wrapper(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      children = _ref.children,
      style = _ref.style,
      name = _ref.name;
  className = "".concat(name ? "name_".concat(name, " ") : "").concat(className);
  return label !== "" ? /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("label", null, label), children) : /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: style
  }, children);
};

var countPages = function countPages(schema) {
  return _lodash["default"].isArray(schema) ? schema.length - 1 : 0;
};

exports.countPages = countPages;

var checkIsPagedInterface = function checkIsPagedInterface(schema) {
  return schema[0] && _lodash["default"].isArray(schema[0]);
};

exports.checkIsPagedInterface = checkIsPagedInterface;

var checkPageIsValid = function checkPageIsValid(currentPageFieldNames, syncErrors) {
  var pageIsValid = true;

  if (!_lodash["default"].isEmpty(currentPageFieldNames) && !_lodash["default"].isEmpty(syncErrors)) {
    var currentPageSyncErrors = _lodash["default"].intersection(currentPageFieldNames, _lodash["default"].keys(syncErrors));

    pageIsValid = _lodash["default"].isEmpty(currentPageSyncErrors);
  }

  return pageIsValid;
};

exports.checkPageIsValid = checkPageIsValid;

var removeFalsyFields = function removeFalsyFields(schema) {
  return schema.map(function (pageGroup) {
    return pageGroup.map(function (group) {
      if (!group.input) {
        return group;
      }

      return _objectSpread(_objectSpread({}, group), {}, {
        input: group.input.filter(Boolean)
      });
    });
  });
};

exports.removeFalsyFields = removeFalsyFields;

var Form = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Form);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fieldsRef", /*#__PURE__*/_react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "schema", function () {
      return checkIsPagedInterface(_this.props.schema) ? _this.props.schema : [_this.props.schema];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePage", function (delta) {
      _this.setState(function (state, props) {
        var updatedPage = state.page + delta;

        _this._handlePageChangeIfAvailable(updatedPage);

        return {
          page: updatedPage
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (v) {
      _this.props.onChange(_this.formRef.current, v);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToTop", function () {
      var elem = document.getElementById(_this.props.form);
      elem.scrollIntoView();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePage", function (delta) {
      _this.setState(function (state, props) {
        var updatedPage = state.page + delta;

        _this._handlePageChangeIfAvailable(updatedPage);

        return {
          page: updatedPage
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
        var schema, dataToSubmit, flattenData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                schema = _this.props.schema; // submitting gets passed down to children

                _this.setState({
                  error: '',
                  submitting: true
                });

                _context.prev = 2;

                if (_lodash["default"].isEmpty((0, _utils.fileUploadFields)(schema))) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return (0, _utils.uploadFileContributions)(data, schema, _this.props.participant);

              case 6:
                _context.t0 = _context.sent;
                _context.next = 10;
                break;

              case 9:
                _context.t0 = data;

              case 10:
                dataToSubmit = _context.t0;
                flattenData = (0, _utils.flattenPayload)(dataToSubmit, schema);

                if (!(0, _utils.phq9Message)(flattenData, schema)) {
                  _context.next = 16;
                  break;
                }

                _this.setState({
                  displayMessage: true,
                  completeSubmit: function completeSubmit() {
                    _this.setState({
                      error: '',
                      submitting: true
                    });

                    try {
                      _this.props.onSubmit(flattenData);
                    } catch (err) {
                      (0, _logger.logError)(err);
                    } finally {
                      _this.setState({
                        submitting: false
                      });
                    }
                  }
                });

                _context.next = 18;
                break;

              case 16:
                _context.next = 18;
                return _this.props.onSubmit(flattenData);

              case 18:
                _context.next = 26;
                break;

              case 20:
                _context.prev = 20;
                _context.t1 = _context["catch"](2);

                if (!(_context.t1 instanceof _SubmissionError["default"])) {
                  _context.next = 24;
                  break;
                }

                throw new _reduxForm.SubmissionError({
                  _error: _context.t1.message
                });

              case 24:
                if (_context.t1.message !== 'uploadSecure') (0, _logger.logError)(_context.t1);

                _this.setState({
                  error: 'There was a problem submitting your request. Please try again or contact us for assistance.'
                });

              case 26:
                _context.prev = 26;

                _this.setState({
                  submitting: false
                });

                return _context.finish(26);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 20, 26, 29]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.state = {
      editing: _this.props.editing,
      page: props.page
    };
    _this.fieldsRef.current = {};
    return _this;
  } // normalizing schema to always be either a "paged" structure, or "single paged" structure


  (0, _createClass2["default"])(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "_handlePageChangeIfAvailable",
    value: function _handlePageChangeIfAvailable(updatedPage) {
      // convenience method to check if prop handlePageChange is avilable and
      // firing the method if available containing the current page
      if (_lodash["default"].isFunction(this.props.handlePageChange)) {
        // increment by 1 for analytics tracking
        this.props.handlePageChange(updatedPage);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!_lodash["default"].isEqual(this.props.page, nextProps.page)) {
        this.setState({
          page: nextProps.page
        }, function () {
          _this2._handlePageChangeIfAvailable(nextProps.page);
        });
      }

      if (!_lodash["default"].isEqual(this.props.editing, nextProps.editing)) {
        this.setState({
          editing: nextProps.editing
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.scrollToTop && this.state.page !== prevState.page) {
        // scrolling to top of form in the case where it is
        // enabled, we have observed the page number has changed
        this.scrollToTop();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          page = _this$state.page,
          editing = _this$state.editing;
      var _this$props = this.props,
          onModifySchema = _this$props.onModifySchema,
          handleSubmit = _this$props.handleSubmit,
          _this$props$noPaging = _this$props.noPaging,
          noPaging = _this$props$noPaging === void 0 ? false : _this$props$noPaging,
          fieldSpacing = _this$props.fieldSpacing,
          nowDate = _this$props.nowDate,
          form = _this$props.form,
          editableFields = _this$props.editableFields,
          editableInterface = _this$props.editableInterface,
          children = _this$props.children,
          schema = _this$props.schema,
          clear_editing_field = _this$props.clear_editing_field,
          error = _this$props.error,
          perPageValidation = _this$props.perPageValidation,
          syncErrors = _this$props.syncErrors,
          asyncErrors = _this$props.asyncErrors,
          valid = _this$props.valid,
          invalid = _this$props.invalid,
          components = _this$props.components,
          participant = _this$props.participant,
          _this$props$translati = _this$props.translationLocale,
          translationLocale = _this$props$translati === void 0 ? 'en' : _this$props$translati,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded); // combining sync and async errors

      var syncAsyncErrors = _objectSpread(_objectSpread({}, syncErrors), asyncErrors); // optimistically setting page to be valid


      var pageIsValid = valid; // if form is invalid, then check if page is valid

      if (!valid && perPageValidation) {
        var fieldPageDictionary = (0, _generateFieldPageDictionary["default"])(schema);
        var currentPageFieldNames = fieldPageDictionary[page]; // overriding variable with checks for current page

        pageIsValid = checkPageIsValid(currentPageFieldNames, syncAsyncErrors);
      } // marking form as invalid while async tasks are being performed


      if (props.asyncValidating !== false) {
        // asyncValidating is either false, or a list of fields being validated
        pageIsValid = false;
      } // passing the autoComplete in this way because setting a default
      // or passing it in directly breaks tests


      var extra_form_props = {};

      if (props.autoComplete) {
        extra_form_props['autoComplete'] = props.autoComplete;
      }

      if (props.noValidate) {
        extra_form_props.noValidate = props.noValidate;
      } // handleSubmit is provided by redux-form, onSubmit is provided by us
      // see https://redux-form.com/7.3.0/examples/submitvalidation/


      return /*#__PURE__*/_react["default"].createElement(_LanguageContext["default"], {
        locale: translationLocale
      }, /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
        className: "__curious_panda",
        onSubmit: handleSubmit(this.onSubmit),
        id: this.props.id || form,
        name: form
      }, extra_form_props), _lodash["default"].map(schema, function (pageGroup, thisPage) {
        return _lodash["default"].map(pageGroup, function (_ref3, groupindex) {
          var _ref3$style = _ref3.style,
              style = _ref3$style === void 0 ? {} : _ref3$style,
              group = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
          var display = page === thisPage ? "inherit" : "none";
          var fields = (0, _transformSchema["default"])(group.input);

          if (noPaging) {
            display = "inherit";
          }

          return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({
            key: "".concat(fields.length, "_").concat(groupindex)
          }, group, {
            style: _objectSpread(_objectSpread({}, style), {}, {
              display: display
            })
          }), _lodash["default"].map(fields, function (_ref4, i) {
            var _ref4$editable = _ref4.editable,
                editable = _ref4$editable === void 0 ? false : _ref4$editable,
                component = _ref4.component,
                fieldKey = _ref4.key,
                field = (0, _objectWithoutProperties2["default"])(_ref4, _excluded3);
            var key = _lodash["default"].has(group, "name") ? "".concat((0, _utils.stripSpecialChars)(group.name), ".") : ""; // creating a field key based on fielset NAME (if we have one)
            // if we do not, just use the field label

            if (_lodash["default"].has(field, 'name')) {
              key += (0, _utils.stripSpecialChars)(field.name);
            } else {
              if (_lodash["default"].indexOf(_constants.allowedNoName, component) !== -1) {
                key += (0, _utils.stripSpecialChars)(field.label);
              } else {
                // depcrecation warning, this will be removed
                key += (0, _utils.stripSpecialChars)(field.label);
                console.warn("Your ".concat(component, " does not contain a \"name\" field. This is a depricated featrure."));
              }
            } // if (_.has(group, `name`)) {
            //   // Group Heading - only applying the name to the key if it's provided
            //   key = stripSpecialChars(`${group.name}.${key}`);
            // }


            if (key === "") {
              key += "".concat((0, _utils.stripSpecialChars)(field.label));
              console.warn("Your form schema for ".concat(field.label, " does not include an apropriate name value, this is a deprecated feature. Please make sure you always supply a \"name\" value."));
            }

            var isEditable = editable && _lodash["default"].includes(editableFields, component);

            field.name = key;
            field['data-testid'] = "filter_".concat(key, "_").concat(i, "_").concat(form, "_").concat(groupindex); // unique identifier for QA test suite

            var FieldContainer = _lodash["default"].has(components, 'field') && components['field']['field_container'];

            var refSetter = function refSetter(ref) {
              _this3.fieldsRef.current = _objectSpread(_objectSpread({}, _this3.fieldsRef.current), {}, (0, _defineProperty2["default"])({}, field.name, ref));

              if (_this3.props.fieldsRef) {
                (0, _refs.setRef)(_this3.props.fieldsRef, _this3.fieldsRef.current);
              }
            };

            var RenderableField = isEditable && !_lodash["default"].isUndefined(FieldContainer) ? /*#__PURE__*/_react["default"].createElement(FieldContainer, (0, _extends2["default"])({
              editing: editing,
              clear_editing_field: clear_editing_field,
              onModifySchema: onModifySchema,
              editableInterface: editableInterface,
              fieldSpacing: fieldSpacing,
              "interface": component,
              form: form,
              components: components
            }, field, {
              disabled: _this3.props.disabled || field.disabled
            }), function (p) {
              return /*#__PURE__*/_react["default"].createElement(_fieldOld["default"], (0, _extends2["default"])({}, p, {
                ref: refSetter
              }));
            }) : /*#__PURE__*/_react["default"].createElement(_fieldOld["default"], (0, _extends2["default"])({
              autoFocus: _this3.props.autoFocus && i === 0,
              fieldSpacing: fieldSpacing,
              "interface": component,
              form: form,
              nowDate: nowDate,
              components: components
            }, field, {
              disabled: _this3.props.disabled || field.disabled,
              submitting: _this3.state.submitting,
              participant: participant,
              displayMessage: _this3.state.displayMessage,
              remoteSubmit: _this3.state.completeSubmit,
              clearAllValidations: _this3.props.clearAllValidations,
              ref: refSetter
            }));
            return /*#__PURE__*/_react["default"].createElement(FieldWrapper, {
              fieldSpacing: fieldSpacing,
              key: fieldKey || key,
              className: field === null || field === void 0 ? void 0 : field.wrapperClass,
              "data-testid": field['data-testid']
            }, field.ComponentWrapper ? /*#__PURE__*/_react["default"].createElement(field.ComponentWrapper, {
              "interface": component,
              name: field.name,
              index: i
            }, RenderableField) : RenderableField);
          }));
        });
      }), (error || this.state.error) && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error || this.state.error), children(_objectSpread(_objectSpread(_objectSpread({}, props), this.state), {}, {
        valid: pageIsValid,
        invalid: !pageIsValid,
        total: countPages(this.props.schema),
        onChangePage: this.onChangePage
      }))));
    }
  }]);
  return Form;
}(_react.Component);

exports.Form = Form;
Form.defaultProps = {
  participant: {},
  editing: undefined,
  page: 0
};

var mapStateToProps = function mapStateToProps(state, props) {
  var formValues = (0, _reduxForm.getFormValues)(props.form)(state);
  var schema = removeFalsyFields( // normalizing schema to always be either a "paged" structure, or "single paged" structure
  checkIsPagedInterface(props.schema) ? props.schema : [props.schema]);

  if (props.perPageValidation) {
    var syncErrors = _lodash["default"].has(state.form[props.form], "syncErrors") ? state.form[props.form].syncErrors : {};
    var asyncErrors = _lodash["default"].has(state.form[props.form], "asyncErrors") ? state.form[props.form].asyncErrors : {};
    return {
      syncErrors: syncErrors,
      asyncErrors: asyncErrors,
      schema: schema,
      formValues: formValues
    };
  }

  return {
    schema: schema,
    formValues: formValues
  };
}; // ordering is important here for the form component to have access to the state sync errors in mapStateToProps


var _default = (0, _reduxForm.reduxForm)({})((0, _reactRedux.connect)(mapStateToProps)(Form));

exports["default"] = _default;